<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('label.contractCode')">
              <j-search-select-tag :placeholder="$t('label.pleaseSelectTheContractCode')" v-model="queryParam.conCode" dict="efs_md_contract,CONCAT(code((comma))((minus))((comma))name),code"/>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('label.whetherValid')">
              <a-radio-group v-model="queryParam.validFlag">
                <a-radio value="Y">{{$t('label.yes')}}</a-radio>
                <a-radio value="N">{{$t('label.no')}}</a-radio>
              </a-radio-group>
            </a-form-item>
          </a-col>
          <!--<a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="批次编码">
              <j-search-select-tag placeholder="请选择批次编码" v-model="queryParam.breedBatchCode" dict="efs_md_breed_batch,name,code"/>
            </a-form-item>
          </a-col>-->
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{$t('button.search')}}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{$t('button.reset')}}</a-button>
              <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? $t('tip.up') : $t('tip.down') }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus">{{$t('button.add')}}</a-button>
<!--      <a-button type="primary" icon="download" @click="handleExportXls('合同价格清单')">{{$t('button.export')}}</a-button>-->
<!--      <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">-->
<!--        <a-button type="primary" icon="import">{{$t('button.import')}}</a-button>-->
<!--      </a-upload>-->
<!--      <a-dropdown v-if="selectedRowKeys.length > 0">-->
<!--        <a-menu slot="overlay">-->
<!--          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>{{$t('button.delete')}}</a-menu-item>-->
<!--        </a-menu>-->
<!--        <a-button style="margin-left: 8px"> {{$t('button.batchOperation')}} <a-icon type="down" /></a-button>-->
<!--      </a-dropdown>-->
    </div>

    <!-- table区域-begin -->
    <div>

      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        class="j-table-force-nowrap"
        :scroll="{x:true}"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        @change="handleTableChange">

        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template v-for="(item, index) in columns" :slot="item.slotName">
          <span :key="index">{{ $t(item.slotName) }}</span>
        </template>

        <template :slot="item.dataIndex" slot-scope="text, record" v-for="item in columns">
          <mtc-lang-list-popover :key="item.dataIndex" :record="record" :item="item" :text="text" />
        </template>
<!--        <template slot="imgSlot" slot-scope="text">-->
<!--          <span v-if="!text" style="font-size: 12px;font-style: italic;">无图片</span>-->
<!--          <img v-else :src="getImgView(text)" height="25px" alt="" style="max-width:80px;font-size: 12px;font-style: italic;"/>-->
<!--        </template>-->
<!--        <template slot="fileSlot" slot-scope="text">-->
<!--          <span v-if="!text" style="font-size: 12px;font-style: italic;">无文件</span>-->
<!--          <a-button-->
<!--            v-else-->
<!--            :ghost="true"-->
<!--            type="primary"-->
<!--            icon="download"-->
<!--            size="small"-->
<!--            @click="downloadFile(text)">-->
<!--            下载-->
<!--          </a-button>-->
<!--        </template>-->

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">{{$t('button.edit')}}</a>

          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">{{$t('button.more')}} <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleDetail(record)">{{$t('button.details')}}</a>
              </a-menu-item>
<!--              <a-menu-item>-->
<!--                <a-popconfirm :title="$t('tip.isDelete')" @confirm="() => handleDelete(record.id)">-->
<!--                  <a>{{$t('button.delete')}}</a>-->
<!--                </a-popconfirm>-->
<!--              </a-menu-item>-->
            </a-menu>
          </a-dropdown>
        </span>

      </a-table>
    </div>

    <efs-md-contract-price-list-modal ref="modalForm" @ok="modalFormOk"/>
  </a-card>
</template>

<script>

  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import EfsMdContractPriceListModal from './modules/EfsMdContractPriceListModal'
  import {filterMultiDictText} from '@/components/dict/JDictSelectUtil'
  import JSearchSelectTag from '@/components/dict/JSearchSelectTag'
  import '@/assets/less/TableExpand.less'

  export default {
    name: "EfsMdContractPriceListList",
    mixins:[JeecgListMixin],
    components: {
      JSearchSelectTag,
      EfsMdContractPriceListModal
    },
    data () {
      return {
        description: '合同价格清单管理页面',
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {
              slotName: 'tableHeader.contractCode',
              scopedSlots: { title: 'tableHeader.contractCode'},
              align:"center",
              dataIndex: 'conCode'
          },
          {
            slotName: 'tableHeader.contractName',
            scopedSlots: { title: 'tableHeader.contractName'},
            align:"center",
            dataIndex: 'conCode_dictText'
          },
          {
            //title:'生效日期',
            slotName: 'tableHeader.effectiveDate',
            align:"center",
            dataIndex: 'effectiveDate',
            customRender:function (text) {
                return !text?"":(text.length>10?text.substr(0,10):text)
            },
            scopedSlots: { title: 'tableHeader.effectiveDate'}
          },
          {
            slotName: 'tableHeader.validOrNot',
            scopedSlots: { title: 'tableHeader.validOrNot'},
            align:"center",
            dataIndex: 'validFlag_dictText'
          },
          {
            slotName: 'tableHeader.operation',
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            scopedSlots: { customRender: 'action', title: 'tableHeader.operation' },
          }
        ],
        url: {
          list: "/contractPriceList/efsMdContractPriceList/list",
          delete: "/contractPriceList/efsMdContractPriceList/delete",
          deleteBatch: "/contractPriceList/efsMdContractPriceList/deleteBatch",
          exportXlsUrl: "/contractPriceList/efsMdContractPriceList/exportXls",
          importExcelUrl: "contractPriceList/efsMdContractPriceList/importExcel",

        },
        dictOptions:{},
      }
    },
    created() {
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      }
    },
    methods: {
      initDictConfig(){
      },

    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>